import Big from "big.js";
import { Comparable } from "./Comparable";
export class Numerical extends Comparable {
    constructor() {
        super();
    }
    static sum(a, b) {
        return a.add(b);
    }
    min(that) {
        this.checkCompatible(that);
        if (this.getRaw().lte(that.getRaw())) {
            return this.replaceWithValue(this.getRaw());
        }
        return this.replaceWithValue(that.getRaw());
    }
    max(that) {
        this.checkCompatible(that);
        if (this.getRaw().gte(that.getRaw())) {
            return this.replaceWithValue(this.getRaw());
        }
        return this.replaceWithValue(that.getRaw());
    }
    add(that) {
        this.checkCompatible(that);
        return this.replaceWithValue(this.getRaw().add(that.getRaw()));
    }
    subtract(that) {
        this.checkCompatible(that);
        return this.replaceWithValue(this.getRaw().sub(that.getRaw()));
    }
    multiply(pct) {
        return this.replaceWithValue(this.getRaw().mul(pct));
    }
    divide(pct) {
        return this.replaceWithValue(this.getRaw().div(pct));
    }
    compare(that) {
        return this.compareRaw(that.getRaw());
    }
    isZero() {
        return this.getSignum() === 0;
    }
    isPositive() {
        return this.getSignum() > 0;
    }
    isNegative() {
        return this.getSignum() < 0;
    }
    getSignum() {
        return this.compareRaw(Numerical.BIG_ZERO);
    }
    compareRaw(raw) {
        return this.getRaw().cmp(raw);
    }
}
Numerical.BIG_ZERO = new Big(0);
//# sourceMappingURL=Numerical.js.map